// Types
import mixins from "vue-typed-mixins";
// Components
import AdminInsetBox from './AdminInsetBox';

// Main
const AdminInputContainer = mixins().extend({
  props: {
    label: {
      type: String,
      default: ''
    },
    for: {
      type: String,
      default: undefined
    },
    noFieldWrap: {
      type: Boolean,
      default: false
    }
  },
  render() {
    var _this$$scopedSlots$de, _this$$scopedSlots, _this$$scopedSlots$de2, _this$$scopedSlots2;
    const h = arguments[0];
    return h("div", {
      "class": "p-2 flex items-center"
    }, [h("label", {
      "attrs": {
        "for": this.for
      },
      "class": 'w-1/6 inline-block'
    }, [this.label]), this.noFieldWrap ? h("div", {
      "class": 'w-5/6 inline-block ml-12 min-w-0'
    }, [(_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots).default) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, {})]) : h(AdminInsetBox, {
      "class": 'w-5/6 inline-block ml-12 min-w-0'
    }, [(_this$$scopedSlots$de2 = (_this$$scopedSlots2 = this.$scopedSlots).default) === null || _this$$scopedSlots$de2 === void 0 ? void 0 : _this$$scopedSlots$de2.call(_this$$scopedSlots2, {})])]);
  }
});
export default AdminInputContainer;